<odx-toast-container></odx-toast-container>
<div>
  @if (initStatus$ | async; as initStatus) {
    @if (initStatus === MasterDataInitStatus.IN_PROGRESS) {
      <div odxLayout="flex vertical-center gap-small" class="w-100 loading-indicator flex-column">
        <app-logo></app-logo>
        <h3 class="odx-title-3" i18n="@@app.hint.loadingProductData.title">Lade Produktdaten</h3>
        <p i18n="@@app.hint.loadingProductData.text">Bitte haben Sie einen Moment Geduld</p>
        <p [odxLoadingSpinner]="true" [odxLoadingSpinnerMinHeight]="100"></p>
      </div>
    }

    @if (initStatus === MasterDataInitStatus.PRODUCT_DATA_FAILED) {
      <app-full-screen-error
        i18n-title="@@app.errorMessage.loadingProductData.title"
        title="Produktdaten konnten nicht geladen werden"
        [description]="errorMessageLoadingProductData"
        [showReloadButton]="true"
      >
      </app-full-screen-error>
    }

    @if (initStatus === MasterDataInitStatus.LOGIN_FAILED && authError$ && (authError$ | async); as authError) {
      @switch (authError.code) {
        @case (AuthError.WRONG_AUTH_LEVEL) {
          <app-full-screen-error
            title="Willkommen bei Navinta!"
            i18n-title="@@app.errorMessage.noAccess.header"
            [description]="errorMessageNoAccess"
          >
          </app-full-screen-error>
        }
        @case (AuthError.OFFLINE) {
          <app-full-screen-error
            title="Offline"
            i18n-title="@@app.errorMessage.offline.header"
            [description]="errorMessageOffline"
            [showReloadButton]="true"
          >
          </app-full-screen-error>
        }
        @default {
          <app-full-screen-error
            title="Fehlerhafter Login"
            i18n-title="@@app.errorMessage.invalidLogin.header"
            [description]="errorMessageInvalidLogin"
            [showReloadButton]="true"
          >
          </app-full-screen-error>
        }
      }
    }
  }
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  @if (!isIframe) {
    <router-outlet></router-outlet>
  }
</div>
